import React from "react";
import { Select } from "antd";

export type SearchableSelectOption = { value: string; label: string };

type Props = {
  value: string;
  onChange: (value: string) => void;
  options: SearchableSelectOption[];
  placeholder?: string;
  disabled?: boolean;
  /** Slightly shorter for inline add rows */
  compact?: boolean;
};

const SearchableSelectField: React.FC<Props> = ({
  value,
  onChange,
  options,
  placeholder = "Search…",
  disabled = false,
  compact = false,
}) => {
  return (
    <div
      className={`searchable-select-field w-full min-w-0 ${
        compact
          ? "[&_.ant-select-selector]:!min-h-[40px]"
          : "[&_.ant-select-selector]:!min-h-[52px]"
      } [&_.ant-select-selector]:!rounded-xl [&_.ant-select-selector]:!border-2 [&_.ant-select-selector]:!border-gray-200 [&_.ant-select-selector]:!shadow-none [&_.ant-select-selector]:!items-center [&_.ant-select-selector]:!overflow-hidden [&_.ant-select-selection-item]:!overflow-hidden [&_.ant-select-selection-item]:!text-ellipsis [&_.ant-select-selection-item]:!whitespace-nowrap [&_.ant-select-selection-item]:!text-base [&_.ant-select-selection-placeholder]:!text-base [&_.ant-select-selection-search]:!min-w-0 [&_.ant-select:hover_.ant-select-selector]:!border-indigo-300 [&_.ant-select-focused_.ant-select-selector]:!border-indigo-500 [&_.ant-select-focused_.ant-select-selector]:!shadow-[0_0_0_2px_rgba(99,102,241,0.15)]`}
    >
      <Select
        showSearch
        allowClear
        disabled={disabled}
        optionFilterProp="label"
        filterOption={(input, option) =>
          String(option?.label ?? "")
            .toLowerCase()
            .includes(input.trim().toLowerCase())
        }
        options={options}
        value={value || undefined}
        onChange={(next) => onChange(next ?? "")}
        placeholder={placeholder}
        size="large"
        style={{ width: "100%" }}
        popupMatchSelectWidth
        listHeight={280}
        getPopupContainer={() => document.body}
        dropdownStyle={{ zIndex: 12050 }}
        styles={{ popup: { root: { zIndex: 12050 } } }}
        popupClassName="quick-create-select-dropdown"
      />
    </div>
  );
};

export default SearchableSelectField;
